import {db} from '@/firebase'
import EventEmitter from 'events'
import { store } from '@/store'

// Extend EventEmitter so user of LanguageRepository can react to our own defined events. (ex: languageRepository.on('added'))
class LanguageRepository extends EventEmitter {
    constructor () {
        super()

        this.collection = db.collection('languages')

        return this
    }

    // Check if a Language exists
    list (onSuccess, onError) {
        this.collection.get()
            .then((querySnapshot) => {
                let countries = {}

                querySnapshot.forEach((doc) => {
                    countries[doc.id] = doc.data()
                });

                onSuccess(countries)
            })
            .catch((error) => {
                onError(error)
            })
    }
}

export default new LanguageRepository()


// WEBPACK FOOTER //
// ./src/data/LanguageRepository.js